import { LIST_CONTAINER_VERTICAL_PADDING } from '../constants/styleConstants';

export declare type ScrollableParentFunction<T = HTMLElement | null> = (element: T) => HTMLElement | null;
export declare type OverflowHiddenParentFunction<T = HTMLElement | null> = (element: T) => HTMLElement | null;

export const getScrollableParent: ScrollableParentFunction = ref => {
  if (ref == null) {
    return null;
  }

  const isElement = ref instanceof HTMLElement;
  const overflowY = isElement && window.getComputedStyle(ref).overflowY;
  const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';

  if (isScrollable && ref.scrollHeight > ref.clientHeight) {
    return ref;
  }

  return ref.parentElement ? getScrollableParent(ref.parentElement) : null;
};

export const getFirstScrollableElement: ScrollableParentFunction = ref => {
  if (ref == null) {
    return null;
  }

  const hasScrollableContent = ref.scrollHeight > ref.clientHeight;
  // const overflowY = window.getComputedStyle(ref).overflowY;
  // const isOverflowHidden = isElement && overflowY.indexOf('hidden') !== -1;

  if (hasScrollableContent) {
    return ref;
  }

  return ref.parentElement ? getFirstScrollableElement(ref.parentElement) : null;
};

export const getOverflowHiddenParent: OverflowHiddenParentFunction = element => {
  if (element == null) {
    return null;
  }
  const overflowYStyle = window.getComputedStyle(element).overflowY;
  const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;

  if (isOverflowHidden) {
    return element;
  } else {
    return element.parentElement ? getOverflowHiddenParent(element.parentElement) : null;
  }
};

export const getOffsetTop = (element: HTMLElement | null): number => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    let isOverflowHidden = false;
    if (element.offsetParent) {
      const overflowYStyle = window.getComputedStyle(element).overflowY;
      isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;
    }
    element =
      element.offsetParent && element.offsetParent.scrollHeight > element.offsetParent.clientHeight && !isOverflowHidden
        ? null
        : (element.offsetParent as HTMLElement);
  }
  return offsetTop;
};

export const getScrollbarWidth = (): number => {
  return window.innerWidth - document.documentElement.clientWidth;
};

export const getInnerOffset = (el: HTMLElement | null): number => {
  let innerOffset = 0;
  if (el) {
    const children = Array.from(el.children);
    children.forEach(child => (innerOffset += child.clientHeight));
  }
  return innerOffset + LIST_CONTAINER_VERTICAL_PADDING * 2; // 32 is top/bottom padding for the element
};
